import { useCallback, useEffect, useState } from 'react';
import { AutomateError, deleteWebhook, getWebhooks } from '../api';
import { useApp } from '../common/AppProvider';
import { translations } from '../translations/translations';
import { Webhook } from './types';
import './webhooks.css';

const Webhooks = () => {
    const { alertError, language } = useApp();
    const [webhooks, setWebhooks] = useState<Record<string, Webhook[] | null>>({});

    const load = useCallback(
        async () =>
            await getWebhooks()
                .then((response) => setWebhooks(response))
                .catch((e: AutomateError) =>
                    alertError({
                        message: translations[language].ERROR_getting_webhooks,
                        traceId: e.json?.traceId,
                    }),
                ),
        [alertError, language],
    );

    useEffect(() => void load(), [load]);

    const onDelete = async (connectorId: string, id: string) => {
        const response = await deleteWebhook(connectorId, id).catch((e: AutomateError) =>
            alertError({
                message: translations[language].ERROR_deleting_webhook,
                traceId: e.json?.traceId,
            }),
        );

        if (response) {
            load();
        }
    };

    return (
        <div className="webhooks">
            {Object.keys(webhooks).map((connectorId) => (
                <div key={connectorId}>
                    <h2>{connectorId}</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>id</th>
                                <th>callbackUri</th>
                                <th>Has Watch</th>
                            </tr>
                        </thead>
                        <tbody>
                            {webhooks[connectorId]?.map((webhook) => (
                                <tr key={webhook.id}>
                                    <td>{webhook.id}</td>
                                    <td>{webhook.callbackUri}</td>
                                    <td>{webhook.hasWatch.toString()}</td>
                                    <td>
                                        <button onClick={() => onDelete(connectorId, webhook.id)}>
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ))}
        </div>
    );
};

export default Webhooks;
